// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__JCvnC","menu":"Menu_menu__XsVla","scroll":"Menu_scroll__Jj3J0","item":"Menu_item__+Zp6r"};